/**
 * Roofer Web Client — Entry Point
 *
 * Boots the CSS, router, and event listeners.
 */

import './main.css';
import { router } from './router/router';
import { LoginPage } from './pages/LoginPage';
import { RegisterPage } from './pages/RegisterPage';
import { DashboardPage } from './pages/DashboardPage';
import { EditorPage } from './pages/EditorPage';
import { SatellitePage } from './pages/SatellitePage';
import { SettingsPage } from './pages/SettingsPage';
import { NotFoundPage } from './pages/NotFoundPage';

// ============================================================
// Application mount
// ============================================================

function bootstrap(): void {
  const appEl = document.getElementById('app');
  if (!appEl) {
    console.error('Could not find #app element');
    return;
  }

  // Register all routes
  router.register({
    path: '/login',
    requiresAuth: false,
    render: () => LoginPage(),
  });

  router.register({
    path: '/register',
    requiresAuth: false,
    render: () => RegisterPage(),
  });

  router.register({
    path: '/dashboard',
    requiresAuth: true,
    render: () => DashboardPage(),
  });

  router.register({
    path: '/editor/:projectId',
    requiresAuth: true,
    render: (params) => EditorPage(params),
  });

  router.register({
    path: '/satellite/:projectId',
    requiresAuth: true,
    render: (params) => SatellitePage(params),
  });

  router.register({
    path: '/settings',
    requiresAuth: true,
    render: () => SettingsPage(),
  });

  // 404
  router.onNotFound(() => NotFoundPage());

  // Handle session expiry / manual logout
  window.addEventListener('auth:logout', () => {
    router.replace('/login');
  });

  // Start routing
  router.init(appEl);
}

bootstrap();
